module.exports = __webpack_public_path__ + "static/media/Hello-09.0a372865.png";